import connect from 'components/Shared/connect';
import { ProductListView } from 'views/ProductPage/productListView';
import {
  getSeriesProducts,
  getProductBrand,
  getBrandUrl,
  getProductSeries,
  getSeriesUrl
} from 'views/ProductPage/selector';
import { rm, NO_ELEMENT, hasElements } from 'utils';
import { ProductSection } from './productSection';
import { ProductPageModel } from 'models/ProductPageModel';
import { DetailedProduct } from 'models/DetailedProduct';
import styles from './productsInSeries.scss';
import { PageState } from 'models/PageState';
import { IconArrow } from 'components/Shared/Icon/themes/BGH-RD3/iconArrow';
import { ListViewProduct } from 'models/ListViewProduct';
import { GtmSelectItem, GtmViewListItem } from 'store/googleTagManager/actions';
import { useDispatch } from 'react-redux';
import {
  getSeriesProductListName,
  mapListViewProductToGtm
} from 'store/googleTagManager/events/utils';

interface OwnProps {
  className?: string;
}

type MergedProps = OwnProps &
  Pick<ProductPageModel, 'productsInSeries'> &
  Pick<DetailedProduct, 'series' | 'brandName'> & {
    seriesUrl: string | false;
  };

const ProductInSeries = ({
  productsInSeries,
  series,
  brandName,
  seriesUrl,
  className
}: MergedProps) => {
  const hasProductsInSeries = hasElements(productsInSeries);
  const reduxDispatch = useDispatch();

  const createGtmProduct = (product: ListViewProduct) => {
    const index = productsInSeries?.indexOf(product) ?? 0;
    const listName = getSeriesProductListName(product);
    return mapListViewProductToGtm({ product, indexInList: index, listName });
  };

  const gtmOnViewItem = (products: ListViewProduct[]) => {
    const gtmItemProducts = products.map(product => createGtmProduct(product));

    reduxDispatch(GtmViewListItem({ gtmItemProducts }));
  };

  const handleProductClick = (product: ListViewProduct) => {
    reduxDispatch(GtmSelectItem({ gtmItemProduct: createGtmProduct(product) }));
  };

  if (!hasProductsInSeries) {
    return NO_ELEMENT;
  }

  return (
    <ProductSection
      classNames={{ wrapper: className, container: styles.section }}
      title={rm('product_productsinseries', series, brandName)}
    >
      {seriesUrl && (
        <a className={styles.seriesLink} href={seriesUrl}>
          {rm('product_productsinseries_showall')} <IconArrow />
        </a>
      )}
      <ProductListView
        onProductClick={handleProductClick}
        products={productsInSeries}
        gtmOnViewItems={gtmOnViewItem}
      />
    </ProductSection>
  );
};

export default connect<MergedProps, OwnProps>((state: PageState) => ({
  productsInSeries: getSeriesProducts(state.currentPage),
  brandName: getProductBrand(state.currentPage),
  brandUrl: getBrandUrl(state.currentPage),
  seriesUrl: getSeriesUrl(state),
  series: getProductSeries(state.currentPage)
}))(ProductInSeries);
